<template>
  <div
    class="c-nav-item j-nav-item"
    :class="{'c-nav-item--mobile':isMobile}"
  >
    <nuxt-link
      v-if="isJustALink"
      class="c-nav-item__navigation t-heading-6"
      :class="{'c-nav-item__navigation--padding':isMobile}"
      :to="item.url"
      :tabindex="myIndex+1"
    >
      {{ item.title }}
      <img
        v-if="isMobile"
        class="c-nav-item__navigation--right"
        src="../../assets/icons/nav-arrow.svg"
        alt=""
      >
    </nuxt-link>
    <button
      v-if="!isJustALink"
      class="c-nav-item__navigation"
      :class="{'c-nav-item__navigation--padding':isMobile}"
      type="button"
      :tabindex="myIndex+1"
      @click="showSubMenu"
      @mouseover="hoverShow"
    >
      <span class="t-heading-6">{{ item.title }}</span>
      <img
        v-if="isMobile"
        class="c-nav-item__navigation--right"
        src="../../assets/icons/nav-arrow.svg"
        alt=""
      >
    </button>
    <div
      v-if="drawingMenu"
      class="c-nav-item__menu u-background-color-base j-nav-item__menu"
      :class="{'c-nav-item__menu--showing':showingMenu, 'c-nav-item__menu--desktop':!isMobile}"
    >
      <header
        v-if="isMobile"
        class="c-nav-item__header j-nav-item__header t-heading-6"
      >
        {{ item.title }}
      </header>
      <div class="c-nav-item__scroll j-nav-item__scroll">
        <div>
          <secondary-nav
            v-if="item.secondaryNavItems && !isMobile"
            :nav-items="item.secondaryNavItems"
            :tabindex-start="tabindexStart+1"
            class="c-nav-item__secondary--desktop"
          />
          <div
            v-if="item.navItems"
            class="c-nav-item__cards l-grid l-grid--3-col"
            :class="{}"
          >
            <nav-card
              v-for="(navItem, index) in item.navItems"
              :key="'c-nav-card_' + index"
              :nav-item="navItem"
              :tabindex="tabindexStart+calculateCardTabIndex(item)+1+index"
              class="c-nav-item__card"
            />
          </div>
          <secondary-nav
            v-if="item.secondaryNavItems && isMobile"
            :nav-items="item.secondaryNavItems"
            :tabindex-start="tabindexStart+1"
            class="c-nav-item__secondary--mobile"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SecondaryNav from "./SecondaryNav";
import NavCard from "./NavCard";
export default {
  name: "NavItem",
  components:{
    SecondaryNav,
    NavCard
  },
  props:{
    item: {
      type: Object,
      default: null
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    myIndex: {
      type: Number,
      default: -1
    },
    tabindexStart: {
      type: Number,
      default: 10
    }
  },
  data: function(){
    return {
      drawingMenu: false,
      showingMenu: false,
      isActive: false,
      menuBottom: null,
      bounceTime: 0
    };
  },
  computed: {
    isJustALink(){
      return !this.item.navItems || this.item.navItems.length === 0;
    }
  },
  watch:{
    $route(){
      this.hideSubMenu();
    }
  },
  methods: {
    showSubMenu(noClose = false){
      if(this.showingMenu && noClose !== true && this.bounceCleared()){
        this.hideSubMenu();
        return;
      }
      if(this.isActive){//if still active, just leave alone
        return;
      }
      this.drawingMenu = true;
      this.isActive = true;
      if(this.bounceCleared()){
        this.bounceTime = Date.now();
      }
      if(this.$parent.$options.name === "MobileNav"
          || this.$parent.$options.name === "DesktopNav"
      ){
        this.$parent.closeOtherMenus(this.myIndex);
      }
      this.$nextTick(() => {
        this.showingMenu = true;
        this.findTop();
        this.sizeScroller();
      });
      if(!this.isMobile){
        setTimeout(() => {
          window.addEventListener("click", this.windowClick);
        }, 500);
      }
    },
    hideSubMenu(){
      this.showingMenu = false;
      this.isActive = false;
      if(!this.isMobile) {
        window.removeEventListener("click", this.windowClick);
        this.stopMouseTracking();
      }
      if(this.$parent.$options.name === "MobileNav"
        || this.$parent.$options.name === "DesktopNav"
      ){
        this.$parent.clearOpen(this.myIndex);
      }
      setTimeout(() => {
        if(!this.isActive){ //only finish hiding if still not active
          this.drawingMenu = false;
        }
      }, 300);
    },
    windowClick(event){
      let target = event.toElement;
      let isInMenu = false;

      while(target.parentElement){
        if(target.classList.contains("j-nav-item")){
          isInMenu = true;
        }
        target = target.parentElement;
      }

      if(!isInMenu){
        this.hideSubMenu();
      }
    },
    sizeScroller(){
      let scrollers = this.$el.getElementsByClassName("j-nav-item__scroll");
      if (scrollers.length > 0) {
        let scroller = scrollers[0];
        if (this.isMobile) {
          const top = this.$el.getElementsByClassName(
            "j-nav-item__menu"
          )[0].getBoundingClientRect().top;
          const headerHeight = this.$el.getElementsByClassName(
            "j-nav-item__header"
          )[0].getBoundingClientRect().height;
          let height = document.documentElement.clientHeight;
          height -= top;
          height -= headerHeight;
          scroller.style.height = `${height}px`;
        } else {
          scroller.style.height = null;
        }
      }
    },
    findTop(){
      let topEl = this.$el.getElementsByClassName("j-nav-item__menu")[0];
      if(this.isMobile){
        topEl.style.top = null; //clear it for normal CSS
      } else {
        let top = 0;
        let bannerEl = document.getElementsByClassName("j-header__banner-height").length > 0 ?
          document.getElementsByClassName("j-header__banner-height")[0]:null;
        let menuEl = document.getElementsByClassName("j-header__menu-height").length > 0 ?
          document.getElementsByClassName("j-header__menu-height")[0]:null;
        top += bannerEl ? bannerEl.getBoundingClientRect().height:0;
        top += menuEl ? menuEl.getBoundingClientRect().height:0;

        topEl.style.top = top + "px";
      }
    },
    calculateCardTabIndex(item){
      if(item.secondaryNavItems){
        return item.secondaryNavItems.length;
      }
      return 0;
    },
    hoverShow(){
      if(!this.isMobile && !this.isActive){
        this.showSubMenu();
        this.startMouseTracking();
      }
    },
    startMouseTracking(){
      window.addEventListener("mousemove", this.trackMouse);
    },
    trackMouse(e){
      if(!this.showingMenu || !this.isActive){
        return;
      }
      let menuEl = this.$el.getElementsByClassName("j-nav-item__menu")[0];
      if(menuEl){
        this.menuBottom = menuEl.getBoundingClientRect().bottom + 25;
      }
      if(this.menuBottom !== null){
        if(this.menuBottom < e.clientY){
          this.hideSubMenu();
        }
      }
    },
    stopMouseTracking(){
      window.removeEventListener("mousemove", this.trackMouse);
    },
    bounceCleared(){
      return Date.now() > (this.bounceTime + 1000);
    }
  }

}
</script>
<style lang="scss" scoped>
  .c-nav-item{
    &--mobile{

    }

    &__navigation{
      @include buttonReset;
      @include themify($themes){
        color: themed("foreground");
      }

      cursor: pointer;
      display: block;
      width: 100%;
      text-align: left;
      text-decoration: none;
      &--right{
        float: right;
      }
      &--top-margin{
        margin-top: rem(9px);
      }

      &--padding{
        padding: $filter-padding;
      }
    }

    &__menu{
      position: fixed;
      top: rem(60px); //default works for mobile
      left: 0;
      opacity: 0;
      width: 100%;
      transition: max-height 0.3s, opacity 0.2s;
      //padding: $filter-padding;
      z-index: ($zindex-global-header - 1);
      height: 100vh; //set default for mobile

      &--desktop{
        max-height: 0%;
        height: 63%;
        overflow-y: auto;
        padding: 0 rem(155px) rem(31px) rem(140px);
        @include themify($themes){
          border-top: $border themed("background", "x-light");
        }

        @media only screen and (max-width: 1800px) {
          padding: 0 rem(90px) rem(31px) rem(80px);
        }

        @media only screen and (max-width: 1640px) {
          padding: 0 rem(45px) rem(31px) rem(40px);
        }

        @media only screen and (max-width: 1575px) {
          padding: 0 rem(35px) rem(31px) rem(40px);
        }

        @media only screen and (max-width: 1500px) {
          padding: 0 rem(20px) rem(31px) rem(10px);
        }
      }
      &--showing{
        opacity: 1;
        max-height: 63%;
      }
    }

    &__close{
      @include buttonReset;
      cursor: pointer;
    }

    &__header{
      text-align: center;
      margin-top: rem(30px);
      &::after {
        @include themify($themes) {
          border-bottom: $border themed("background", "x-light");
        }
        content: "";
        display: block;
        margin: 0 auto;
        width: 50%;
        padding-top: rem(15px);
      }
    }

    &__scroll{
      overflow-y: auto;
      padding: rem(60px) rem(140px);
      padding-bottom: rem(20px);
      max-height: 520px;
      @media only screen and (max-width: 1600px) {
        padding: rem(40px) 0 rem(20px) 0;
      }
      @include respond("tab-land"){
        padding: rem(40px) 0 rem(20px) 0;
      }
    }

    &__secondary{
      &--desktop{
        float: left;
        width: 12%;
        @media only screen and (max-width: 1500px) {
          width: 14%;
        }
      }
      &--mobile{
        padding: $filter-padding;
      }
    }

    &__cards{
      float: right;
      width: 87%;
      grid-gap: 1rem;
      @media only screen and (max-width: 1500px) {
        width: 85%;
      }
      @include respond("tab-land"){
        float: none;
        width: inherit;
      }
    }

    &__card {
      height: 100%;
      display: flex;
    }
  }
</style>
